<template>
  <div class="login_box" v-if="popup_json.show">
    <div class="login_ct">
      <div class="login_mark"></div>
      <div class="login_option">
        <!-- 头部渐变 -->
        <div class="linear">
          <div class="linear_lt">
            <!-- <img v-if="phoneSteep === 1"
              :src="isloginType == 'phone' ? require('@/assets/image/phone_icon.png') : require('@/assets/image/pass_icon.png')"
              alt=""> -->
          </div>
          <div class="code_title">{{ popup_json.text }}</div>
          <div class="linear_rt">
            <img @click="handelClosePop" src="@/assets/image/reserve_cancel_ic.png" alt="">
          </div>
        </div>
        <div class="main" v-html="html_content">

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import regMethods from '@/mixs/regMethods'
import { postData } from '@/api/api.js'
import { mapMutations, mapState } from 'vuex'
import Bus from '@/util/Bus'

export default {
  name: 'ServerPopup',
  props: {
    popup_json: {
      type: Object,
      required: true,
      default: () => ({}) // ✅ 默认值用函数返回对象
    }
  },
  mixins: [regMethods],
  data() {
    return {
      information: [],
    }
  },
  created() {
    if (this.popup_json.type == 3) return this.byDeviceId();
    this.getGameInfoById();
  },
  computed: {
    ...mapState(['uid', 'requestParams', 'platform']),
    html_content: function () {
      if (this.popup_json.type == 3) {
        return this.information.content;
      } else if (this.popup_json.type == 2) {
        return this.information.permission_policy;
      } else {
        return this.information.privacy_policy;
      }

    }
  },
  watch: {
    // 监听 popup_json.id 的变化
    'popup_json.id': function (newVal, oldVal) {
      // 当 popup_json.id 改变时触发
      if (this.popup_json.type == 3) {
        this.byDeviceId();
      } else {
        this.getGameInfoById();
      }
    }
  },
  methods: {
    ...mapMutations(['handelUid', 'clearLoggedInUser', 'handelSdkGid']),

    // 关登录弹窗
    handelClosePop() {
      Bus.$emit("serverPopopShow", { ...this.popup_json, show: false });
    },
    async byDeviceId() {
      if (!this.popup_json.id) return
      const endpoint = '/box/install-guide/article/byDeviceId'
      const params = {
        device_id: this.popup_json.id,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      try {
        const res = await postData(endpoint, params)
        if (res?.code === 0) {
          this.information = res.data;
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 盒子获取指定游戏
    async getGameInfoById() {
      if (!this.popup_json.id) return
      const endpoint = '/box/by-id'
      const params = {
        uid: this.uid,
        lid: this.requestParams.lid,
        id: this.popup_json.id,
        platform: this.platform,
        subchannelnum: this.requestParams.subchannelnum,//广告商分包id
      }
      try {
        const res = await postData(endpoint, params)
        if (res?.code === 0) {
          this.information = res.data;
          return
        } else {
          // this.$toast.show({
          //     msg: res.msg
          // })
        }
      } catch (err) {
        console.log(err)
      }
    },
  },

}
</script>

<style scoped lang="less">
.login_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
}

.login_ct {
  position: relative;
  width: 100%;
  height: 100%;

  .login_mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .login_option {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 550px;
    // min-height: 384px;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 0 0 40px 0;
    z-index: 2;

    .linear {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 50px;
      padding: 25px 26px 10px 16px;
      box-sizing: border-box;
      border-radius: 20px 20px 0 0;
      background: linear-gradient(to bottom, #FFE8E9, #FFFFFF);

      .linear_lt {
        cursor: pointer;
      }

      .code_title {
        font-size: 20px;
        font-weight: 700;
      }

      .linear_rt {
        width: 16px;
        height: 16px;
        // align-self: flex-start;
      }
    }

    .main {
      max-height: 384px;
      min-height: 100px;
      overflow-y: auto;
      font-size: 16px;
      padding: 10px 25px;
      box-sizing: border-box;
      // color: rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
